import { makeStyles } from '../../../../styles';
export const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.spacing(1),
    },
}));
//# sourceMappingURL=LightweightFilters.styles.js.map